import * as types from '../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.SET_USER_ITEMS:
            return action.payload;
        case types.DELETE_ITEM:
            return state.filter((items) => {
                return items.itemId !== action.payload;
            });
        default:
        return state;
    }
};